import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "start" }}>
            Me llamo <span className="purple">Diego Cari </span>
            y soy de <span className="purple"> Jujuy, Argentina.</span>
            <br />
            Soy un Desarrollador Web especializado en JavaScript con ganas de
            seguir formándome como profesional.
            <br />
            <br />
            No dudes en contactarme en cualquier momento, tengo un horario muy
            flexible !y lo ocuparé para terminar tu proyecto lo mejor y más
            rápido posible!
            <br />
            <br />
            Aparte de programar, tengo otras actividades que me gustan
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Video juegos
            </li>
            <li className="about-activity">
              <ImPointRight /> Películas
            </li>
            <li className="about-activity">
              <ImPointRight /> Viajar
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
